/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

import {
  saveReconField
} from '../api/setFormData'
const initialState = {
  // initialValues
}

export default function ReconInfoReducer(state = initialState, action) {
  switch (action.type) {
    case 'INITIALIZE_VALUES_RECON': {
      return Object.assign({}, {}, { ...action.payload })//this is just the recon object, so replace it every time
    }
    case 'UPDATE_RECON_FIELD': {
      return Object.assign({}, state,  action.payload )
    }
    case 'UPDATE_RECON_DATE': {
      let newObj = Object.assign({}, state[action.object])
      newObj.epochs = action.payload
      return Object.assign({}, state, { [action.object]: newObj })
    }
    case 'SAVE_RECON_FIELD': {
      saveReconField(action.field, action.payload)
      return state
    }

    default:
      return state
  }
}
